import { Link } from "react-router-dom";
import { loginUrl, useEvidenceBase } from "../utils/pageBase";

const CSS = `
.ch-login { font-size: 13px; font-style: italic; color: var(--ch-ink2); }
.ch-login a { color: var(--ch-ink); font-style: normal; text-decoration: underline; text-underline-offset: 3px; }
`;

/** "Log in to run more queries", for logged-out visitors who used their free query. */
export function LoginPrompt({ className }: { className?: string }) {
  const base = useEvidenceBase();
  return (
    <span className={`ch-login${className ? ` ${className}` : ""}`}>
      <style>{CSS}</style>
      <Link to={loginUrl(base)}>Log in</Link> to run more queries
    </span>
  );
}
